import React from "react";
import Navbar from "../Components/Navbar";
import '../Styles/AboutGoodNews.scss';
import {Helmet} from "react-helmet";
import Footer from "../Components/Footer.js";

function AboutGoodNews() {
   return (
      <div>
      <Helmet>
            <title>Good News - Camp Connect</title>
         </Helmet>
      <div className="GoodNewsOuterContainer">
         <Navbar/>

         <div className="GoodNewsInnerContainer">

            <div className="GoodNewsTitleOuterContainer">
               <div className="GoodNewsTitleInnerContainer">
                  <div className="GoodNewsTitleText1">
                     <>God's Free Gift</>
                  </div>

                  <div className="GoodNewsTitleText2">
                     <>God wants you to receive His free gift of salvation and spend eternity with Him in heaven</>
                  </div>
               </div>
            </div>


            <div className="GoodNewsTextBoxesOuterContainer">
               <div className="GoodNewsTextBoxInnerContainer">

                  <div id="goodNewsText">
                  <>
                  Today the world’s population is over 7 billion people and counting. With such a great number of people on earth, it would be easy to feel lost in the crowd.
                  <br></br>
                  <br></br>
                  Yet God knows you and He loves you very much. He wants you to receive His free gift of salvation and spend eternity with Him in heaven.
                  </>
                  <br></br>
                  <br></br>
                  </div>

                  <div id="goodNewsTextBig">
                  <h3>
                  IT MAY BE HARD TO ADMIT, BUT WE ALL HAVE SINNED.
                  </h3>
                  </div>

                  <div id="goodNewsText">
                  <>
                  <br></br>
                  God tells us in His Word, the Bible…
                  </>
                  <br></br>
                  <br></br>
                  <br></br>
                  
                  <i id="goodNewsTextMargin">
                  There is none righteous, no, not one…. For all have sinned, and come short of the glory of God. 
                  <b>
                     &nbsp;Romans 3:10, 23
                  </b>
                  </i>
                  <br></br>
                  <br></br>
                  <br></br>
                  <>
                  No one can be good enough to get to heaven. God demands holiness, and as sinners, we fall short. Because we fall short, we will spend eternity separated from God.
                  </>
                  <br></br>
                  <br></br>
                  </div>

                  

                  <div id="goodNewsTextBig">
                  <h3>
                  HOWEVER, THERE IS GOOD NEWS!
                  </h3>
                  </div>

                  <div id="goodNewsText">
                  <>
                  <br></br>
                  God loves us so much that He provided a way for us to go to heaven.
                  <br></br>
                  <br></br>
                  <br></br>

                  <i id="goodNewsTextMargin">
                  But God commendeth his love toward us, in that, while we were yet sinners, Christ died for us. 
                  <b>
                  &nbsp;Romans 5:8
                  </b>
                  </i>
                  <br></br>
                  <br></br>
                  <br></br>

                  God sent His Son, Jesus, who died on the cross for our sins. Because Jesus took our place, we can live forever with God in heaven.
                  <br></br>
                  <br></br>
                  <br></br>

                  <i id="goodNewsTextMargin">
                  For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life. 
                  <b>
                  &nbsp;John 3:16
                  </b>
                  </i>

                  <br></br>
                  <br></br>
                  <br></br>

                  Whosoever means anyone, regardless of background, status, age, or past. This gift of salvation is freely available to all.
                  <br></br>
                  <br></br>
                  </>
                  </div>

                  <div id="goodNewsTextBig">
                  <h3>
                  RECEIVE JESUS CHRIST AS YOUR SAVIOR.
                  </h3>
                  </div>

                  <div id="goodNewsText">
                  <>
                  <br></br>
                  To receive God’s free gift of salvation, simply believe on the Lord Jesus Christ. The Bible says…
                  <br></br>
                  <br></br>
                  <br></br>
                  <i id="goodNewsTextMargin">
                  That if thou shalt confess with thy mouth the Lord Jesus, and shalt believe in thine heart that God hath raised him from the dead, thou shalt be saved.
                  <b>
                  &nbsp;Romans 10:9
                  </b>
                  </i>

                  <br></br>
                  <br></br>
                  <br></br>
                  Will you receive Jesus as your Savior today?
                  <br></br>
                  <br></br>
                  &nbsp;Lord, I know that I am a sinner. I want to ask you to forgive my sin and be my Savior. In Jesus’ name, Amen.
                  </>
                  </div>
               </div>
            </div>

            </div>

      </div>
      <Footer/>
      </div>


   )
};

export default AboutGoodNews;
